import { MEDIA_WIDTH, MEDIA_HEIGHT } from '../../../../../ReusableFormFields/AdFileUpload/fields'

// Calculates the number of unique creative sizes that have been uploaded
// and match the requested creative placeholder sizes
export const calculateUploadedCreativeSizes = (uploadedCreatives = [], creativePlaceholders = []) => {
  if (!uploadedCreatives.length || !creativePlaceholders.length) {
    return 0
  }

  const uploadedSizes = new Set()

  // Create a set of requested sizes for faster lookup
  const requestedSizes = new Set(
    creativePlaceholders.map(placeholder => `${placeholder.size.width}x${placeholder.size.height}`)
  )

  uploadedCreatives.forEach(creative => {
    const creativeSize = `${creative[MEDIA_WIDTH]}x${creative[MEDIA_HEIGHT]}`
    if (requestedSizes.has(creativeSize)) {
      uploadedSizes.add(creativeSize)
    }
  })

  return uploadedSizes.size
}
